function isNumberLike(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        value instanceof String ||
        value instanceof Number);
}
function isEntryWise(value) {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    return (Symbol.iterator in value ||
        typeof value.length === 'number');
}
export function toFiniteNumber(value, defaultValue) {
    if (value === undefined || value === null) {
        return defaultValue;
    }
    if (isNumberLike(value)) {
        const converted = Number(value);
        return Number.isFinite(converted) ? converted : defaultValue;
    }
    if (!isEntryWise(value)) {
        return defaultValue;
    }
    return Array.from(value, (entry) => {
        const converted = Number(entry);
        return Number.isFinite(converted) ? converted : defaultValue;
    });
}
export function toNumber(val) {
    if (val === undefined || val === null) {
        return undefined;
    }
    if (isNumberLike(val)) {
        return Number(val);
    }
    if (Array.isArray(val)) {
        return val.map((entry) => Number(entry));
    }
    if (typeof val === 'object' && Symbol.iterator in val) {
        return Array.from(val, (entry) => Number(entry));
    }
    return Number(val);
}
export default toNumber;
